import React, { useEffect, useState } from 'react'
import style from './ReportForm.module.css'
import { useForm } from 'react-hook-form'
import ReportSpecChart from './ReportSpecChart'
import { getFileName } from '../../../utils/file/file'
import { FaFileAlt } from 'react-icons/fa'
import parse from 'html-react-parser';

const ReportFormRead = ({ reportInfo, savedFiles, pdfRef }) => {
    /* React Hook Form */
    const { reset, watch, getValues } = useForm()

    useEffect(() => {
        reset(reportInfo)
    }, [reportInfo])

    /* 스펙분석 - 차트데이터 */
    const [specChartData, setSpecChartData] = useState([0, 0, 0, 0, 0])
    const specGpaValue = watch("specGpa");
    const specAccreditedValue = watch("specAccredited");
    const specClubValue = watch("specClub");
    const specAwardValue = watch("specAward");
    const specLeadershipValue = watch("specLeadership");
    useEffect(() => {
        const updatedData = [
            Number(specGpaValue) || 0,
            Number(specAccreditedValue) || 0,
            Number(specClubValue) || 0,
            Number(specAwardValue) || 0,
            Number(specLeadershipValue) || 0,
        ];

        setSpecChartData(updatedData);
    }, [specGpaValue, specAccreditedValue, specClubValue, specAwardValue, specLeadershipValue]);

    return (
        <div className={style.formWrap} ref={pdfRef}>
            <form id='reportForm' className={style.form}>
                <div className={style.titleWrap}>
                    <h1 className={`${style.title} mb-3`}>KGS 메가반 학생 분석 보고서</h1>
                    <p className='fs-5 text-center'>학생의 학업 성취와 한국대학 진로계획을 위한 분석 보고서입니다.</p>

                </div>

                <div className={style.contentWrap}>

                    {/* 1. 학생정보 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>학생정보</h2>

                        <div className={style.sectionContent}>
                            <div className='mb-2'>
                                <label htmlFor='userName' className='form-label'>이름</label>
                                <ValuePrintBoxBorderNone value={getValues('userName')} />
                            </div>

                            <div className='mb-2'>
                                <label htmlFor='userGrade' className='form-label'>학년</label>
                                <ValuePrintBoxBorderNone value={getValues('userGrade')} />
                            </div>
                        </div>

                        <div className={style.sectionContent}>
                            <h3 className={style.sectionSubTitle}>대학목표</h3>
                            <div className='mb-3'>
                                <label htmlFor='targetType' className='form-label'>전형</label>
                                <ValuePrintBoxBorderNone value={getValues('targetType')} />
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='targetUniversity' className='form-label'>목표대학</label>
                                <ValuePrintBoxBorderNone value={getValues('targetUniversity')} />
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='targetMajor' className='form-label'>전공</label>
                                <ValuePrintBoxBorderNone value={getValues('targetMajor')} />
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />


                    {/* 2. 객관적인 스펙 분석 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>객관적인 스펙 분석</h2>

                        <div className={style.sectionContent}>
                            <div className={style.specChartWrap}>
                                <ReportSpecChart chartData={specChartData} />
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />


                    {/* 3. 심리검사 결과 분석 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>심리검사 결과 분석</h2>
                        <div className={style.sectionContent}>
                            <div className={`${style.downloadSection} mb-5`}>
                                <h3 className={style.sectionSubTitle}>심리검사 결과지 다운로드</h3>
                                <div style={{ padding: "1rem", border: "1px solid #e5e5e5", borderRadius: "0.35rem" }}>
                                    <SavedFileList savedFiles={savedFiles} />
                                </div>
                            </div>

                            {/* MCI */}
                            <div className=''>
                                <h3 className={style.sectionSubTitle}>MCI 검사 분석</h3>
                                <div>
                                    <div className='mb-4'>
                                        <label htmlFor='mciJob' className='form-label'>1. 추천직업</label>
                                        {/* <textarea {...register('mciJob')} id="mciJob" className='form-control-plaintext' style={{ height: "200px" }} readOnly disabled /> */}
                                        <ValuePrintBox value={getValues('mciJob')} />
                                    </div>

                                    <div className='mb-4'>
                                        <label htmlFor='mciDepartment' className='form-label'>2. 추천계열</label>
                                        {/* <textarea {...register('mciDepartment')} id="mciDepartment" className='form-control-plaintext' readOnly disabled rows={2} /> */}
                                        <ValuePrintBox value={getValues('mciDepartment')} />

                                    </div>

                                    <div className='mb-4'>
                                        <label htmlFor='mciMajor' className='form-label'>3. 추천전공</label>
                                        {/* <textarea {...register('mciMajor')} id="mciMajor" className='form-control-plaintext' readOnly disabled rows={2} /> */}
                                        <ValuePrintBox value={getValues('mciMajor')} />

                                    </div>
                                </div>
                            </div>

                            {/* SLT */}
                            <div className='mt-5'>
                                <h3 className={style.sectionSubTitle}>SLT 검사 분석</h3>
                                <div>
                                    <div className='mb-4'>
                                        <label htmlFor='sltStrength' className='form-label'>1. 강점 학습전략</label>
                                        <ValuePrintBox value={getValues('sltStrength')} />
                                    </div>

                                    <div className='mb-4'>
                                        <label htmlFor='sltWeakness' className='form-label'>2. 약점 학습전략</label>
                                        <ValuePrintBox value={getValues('sltWeakness')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />

                    {/* 4. SWOT 분석 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>SWOT 분석</h2>

                        <div className={style.sectionContent}>
                            <div className='mt-5'>
                                <div className='mb-4'>
                                    <label htmlFor='swotStrength' className='form-label'>1. 강점(Strength)</label>
                                    <ValuePrintBox value={getValues('swotStrength')} />
                                </div>

                                <div className='mb-4'>
                                    <label htmlFor='swotWeakness' className='form-label'>2. 약점(Weakness)</label>
                                    <ValuePrintBox value={getValues('swotWeakness')} />
                                </div>

                                <div className='mb-4'>
                                    <label htmlFor='swotOpportunity' className='form-label'>3. 기회(Opportunity)</label>
                                    <ValuePrintBox value={getValues('swotOpportunity')} />
                                </div>

                                <div className='mb-4'>
                                    <label htmlFor='swotThreat' className='form-label'>4. 위협(Threat)</label>
                                    <ValuePrintBox value={getValues('swotThreat')} />
                                </div>

                                <div className='mb-4'>
                                    <label htmlFor='swotKeyword' className='form-label'>5. 목표대학 합격을 위한 중심 키워드</label>
                                    <ValuePrintBox value={getValues('swotKeyword')} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />


                    {/* 5. 추천 전형, 대학, 전공 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>추천 전형, 대학, 전공</h2>

                        <div className={style.sectionContent}>
                            <div className='mb-4'>
                                <label htmlFor='recommendType' className='form-label'>1. 추천전형</label>
                                <ValuePrintBox value={getValues('recommendType')} />
                            </div>

                            <div className='mb-4'>
                                <label htmlFor='recommendUniversity' className='form-label'>2. 추천대학</label>
                                <ValuePrintBox value={getValues('recommendUniversity')} />
                            </div>

                            <div className='mb-4'>
                                <label htmlFor='recommendMajor' className='form-label'>3. 추천전공</label>
                                <ValuePrintBox value={getValues('recommendMajor')} />
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />


                    {/* 6. 단기 학습 목표 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>단기 학습 목표</h2>

                        {/* <div className={style.sectionContent}>
                            <h3 className={style.sectionSubTitle}>학기말까지 목표</h3>
                            <div className=''>
                                <div className='mb-4'>
                                    <label htmlFor='shortSemesterSchoolScore' className='form-label'>1. 학교성적</label>
                                    <ValuePrintBox value={getValues('shortSemesterSchoolScore')} />
                                    <div className='mb-2'></div>
                                    <ValuePrintBox value={getValues('shortSemesterSchoolComment')} />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor='shortSemesterOfficial' className='form-label'>2. 공인시험성적</label>
                                    <ValuePrintBox value={getValues('shortSemesterOfficial')} />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor='shortSemesterExtra' className='form-label'>3. 비교과활동</label>
                                    <ValuePrintBox value={getValues('shortSemesterExtra')} />
                                </div>
                            </div>
                        </div> */}

                        <div className={style.sectionContent}>
                            <h3 className={style.sectionSubTitle}>학년말까지 목표</h3>
                            <div className=''>
                                <div className='mb-4'>
                                    <label htmlFor='shortYearSchoolScore' className='form-label'>1. 학교성적</label>
                                    <ValuePrintBox value={getValues('shortYearSchoolScore')} />
                                    <div className='mb-2'></div>
                                    <ValuePrintBox value={getValues('shortYearSchoolComment')} />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor='shortYearOfficial' className='form-label'>2. 공인시험성적</label>
                                    <ValuePrintBox value={getValues('shortYearOfficial')} />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor='shortYearExtra' className='form-label'>3. 비교과활동</label>
                                    <ValuePrintBox value={getValues('shortYearExtra')} />
                                </div>
                            </div>
                        </div>

                    </div>
                    <hr className={style.hr} />


                    {/* 7. 장기 학습 목표 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>장기 학습 목표</h2>

                        <div className={style.sectionContent}>
                            <h3 className={style.sectionSubTitle}>12학년 1학기까지 목표</h3>
                            <div className=''>
                                <div className='mb-4'>
                                    <label htmlFor='longSchoolScore' className='form-label'>1. 학교성적</label>
                                    <ValuePrintBox value={getValues('longSchoolScore')} />
                                    <div className='mb-2'></div>
                                    <ValuePrintBox value={getValues('longSchoolComment')} />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor='longOfficial' className='form-label'>2. 공인시험성적</label>
                                    <ValuePrintBox value={getValues('longOfficial')} />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor='longExtra' className='form-label'>3. 비교과활동</label>
                                    <ValuePrintBox value={getValues('longExtra')} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />

                    {/* 8. 대학 지원 준비 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>대학 지원 준비</h2>

                        <div className={style.sectionContent}>
                            <div className='mb-4'>
                                <label htmlFor='readyRecommendation' className='form-label'>1. 지원 대학 추천</label>
                                <ValuePrintBox value={getValues('readyRecommendation')} />
                            </div>
                            <div className='mb-4'>
                                <label htmlFor='readyIntroduction' className='form-label'>2. 자기소개서</label>
                                <ValuePrintBox value={getValues('readyIntroduction')} />
                            </div>
                            <div className='mb-4'>
                                <label htmlFor='readyDocument' className='form-label'>3. 제출서류</label>
                                <ValuePrintBox value={getValues('readyDocument')} />
                            </div>
                        </div>
                    </div>
                    <hr className={style.hr} />

                    {/* 9. 맞춤형 학습 전략 */}
                    <div className={style.section}>
                        <h2 className={style.sectionTitle}>맞춤형 학습 전략</h2>

                        <div className={style.sectionContent}>
                            <div className='mb-4'>
                                <label htmlFor='strategyAcademic' className='form-label'>1. 학업 성취 전략</label>
                                <HtmlPrintBox value={getValues('strategyAcademic')} />
                            </div>

                            <div className='mb-4'>
                                <label htmlFor='strategyExtracurricular' className='form-label'>2. 비교과 활동 전략</label>
                                <HtmlPrintBox value={getValues('strategyExtracurricular')} />
                            </div>

                            <div className='mb-4'>
                                <label htmlFor='strategyTime' className='form-label'>3. 시간 관리 전략</label>
                                <HtmlPrintBox value={getValues('strategyTime')} />
                            </div>

                            <div className='mb-4'>
                                <label htmlFor='strategyGoal' className='form-label'>4. 목표 관리 전략</label>
                                <HtmlPrintBox value={getValues('strategyGoal')} />
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div >
    )
}


const SavedFileList = ({ savedFiles }) => {
    return (
        <ul>
            {savedFiles.map((file, index) => {
                const fileName = getFileName('report', file)

                return (
                    <li key={'savedFileItem' + index} className='file-list__item'>
                        <div className='file-list__filename'>
                            <a href={file} download={fileName} className='download-link'><FaFileAlt /> {fileName}</a>
                        </div>
                    </li>
                )
            })}
            {savedFiles.length === 0 && <p>업로드된 파일이 없습니다.</p>}
        </ul>
    )
}


const HtmlPrintBox = ({ value }) => {
    const printBoxStyle = {
        padding: "1rem 0.75rem",
        lineHeight: "1.5rem",
        whiteSpace: "pre-wrap",
        border: "1px solid rgb(235, 235, 235)",
        borderRadius: "0.35rem",
    }

    return (
        <div style={printBoxStyle} className='ql-editor'>{value && parse(value)}</div>
    )
}

const ValuePrintBox = ({ value }) => {
    const printBoxStyle = {
        padding: "1rem 0.75rem",
        lineHeight: "1.5rem",
        whiteSpace: "pre-wrap",
        border: "1px solid rgb(235, 235, 235)",
        borderRadius: "0.35rem",
    }

    let formattedText = ''
    if (value) {
        formattedText = value.replace(
            /<a>(.*?)<\/a>/g,
            '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
        );
    }

    return (
        <div style={printBoxStyle}>
            {/* {value} */}
            {parse(formattedText)}
        </div>
    )
}
const ValuePrintBoxBorderNone = ({ value }) => {
    const printBoxStyle = {
        padding: "0.5rem 0.75rem 1rem",
        lineHeight: "1.2rem",
        whiteSpace: "pre",
        border: "0",
    }

    let formattedText = ''
    if (value) {
        formattedText = value.replace(
            /<a>(.*?)<\/a>/g,
            '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
        );
    }

    return (
        <div style={printBoxStyle}>
            {parse(formattedText)}
        </div>
    )
}

export default ReportFormRead